var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEgld(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "#000",
    rx: 8
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#23F7DD",
    d: "m8.447 8 3.713-1.893-.625-1.146-3.4 1.313a.377.377 0 0 1-.271 0l-3.4-1.313-.624 1.146L7.553 8 3.84 9.895l.624 1.146 3.4-1.313a.378.378 0 0 1 .272 0l3.4 1.313.624-1.146-3.713-1.894Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEgld);
export default __webpack_public_path__ + "static/media/egld.e6855047eb43d43233afc01b73afac12.svg";
export { ForwardRef as ReactComponent };